export function CostOfDeviationStack({ bars, addressable, structural, testId }) {
  if (!bars) return null;
  const max = Math.max(...bars.map((b) => b.value_per_day || 0), 1);
  return (
    <div className="space-y-3" data-testid={testId}>
      <div className="space-y-2">
        {bars.map((b, i) => (
          <div key={i} className="flex items-center gap-2" data-testid={`cod-bar-${i}`}>
            <span className="text-[10px] w-40 truncate text-[var(--oim-text-muted)] shrink-0">{b.mechanism || b.category}</span>
            {b.unavailable ? (
              <span className="text-[9px] font-heading uppercase px-1.5 py-0.5 rounded-full border border-[var(--oim-border)] text-[var(--oim-text-dim)]">UNAVAILABLE</span>
            ) : (
              <>
                <div className="flex-1 h-2 rounded-sm" style={{ backgroundColor: "var(--oim-surface-softer)" }}>
                  <div className="h-2 rounded-sm" style={{ width: `${(b.value_per_day / max) * 100}%`, backgroundColor: "var(--oim-text-secondary)" }} />
                </div>
                <span className="font-mono-data text-xs text-[var(--oim-text)] w-24 text-right shrink-0">
                  ₹{Math.round(b.value_per_day).toLocaleString("en-IN")}/d
                </span>
              </>
            )}
          </div>
        ))}
      </div>
      {(addressable != null || structural != null) && (
        <div className="grid grid-cols-2 gap-3 pt-2 border-t border-[var(--oim-border)] font-mono-data text-xs">
          <div>
            <span className="text-[9px] text-[var(--oim-text-dim)] block">Addressable</span>
            <span className="text-[var(--oim-text)] font-semibold">₹{Math.round(addressable).toLocaleString("en-IN")}/day</span>
          </div>
          <div>
            <span className="text-[9px] text-[var(--oim-text-dim)] block">Structural <em className="text-[var(--oim-text-dim)] not-italic">(context, not opportunity)</em></span>
            <span className="text-[var(--oim-text-muted)] font-semibold">₹{Math.round(structural).toLocaleString("en-IN")}/day</span>
          </div>
        </div>
      )}
    </div>
  );
}
